import React, { useState } from "react";
import { Row, Col, Card, Table, Tabs, Tag, Input } from "antd";

const TradesSection = ({ data }) => {
    // const [tab, setTab] = useState("all");

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Instrument",
      dataIndex: "instrument",
    },
    {
      title: "Entry",
      dataIndex: "entry",
    },
    {
      title: "P&L",
      dataIndex: "pnl",
      render: (v) => (
        <span style={{ color: v > 0 ? "#2ecc71" : "#e74c3c" }}>
      ₹{Number(v).toFixed(2)}
        </span>
      ),
    },
    // {
    //   title: "RR",
    //   dataIndex: "rr",
    // },
  ];

  const datas = [
    {
      key: 1,
      date: "Tue, Dec 16 2025",
      instrument: "BankNIFTY",
      entry: "46,200",
      pnl: 1600,
      rr: 2.0,
    },
    {
      key: 2,
      date: "Thu, Jan 8 2026",
      instrument: "NIFTY",
      entry: "23,180",
      pnl: -650,
      rr: -0.7,
    },
  ];
const [tab, setTab] = useState("all");

const trades =
  tab === "wins"
    ? data?.win_loss?.wins || []
    : tab === "loss"
    ? data?.win_loss?.losses || []
    : data?.win_loss?.all || [];

  const tableData = (trades || []).map((t, i) => ({
  key: i,
  date: t.opening_date
    ? new Date(t.opening_date).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-",
  instrument: t.symbol,
  entry: t.opening_price,
  pnl: t.profit,
  rr: t.rr || "-",
}));
  return (
<Row gutter={[16, 16]} style={{ marginTop: 20 }}>      
      {/* LEFT TABLE */}
<Col xs={24} lg={14}>        <Card title="Trades">
          
     <Tabs
  activeKey={tab}
  onChange={(k) => setTab(k)}
  items={[
    { key: "all", label: "All" },
    { key: "wins", label: "Wins" },
    { key: "loss", label: "Losses" },
  ]}
/>

          {/* <Table
            columns={columns}
dataSource={tableData}       
     pagination={false}
            size="small"
          /> */}
<Table
  columns={columns}
  dataSource={tableData}
  pagination={false}
  size="small"
  scroll={{ x: 600 }}
/>
        </Card>
      </Col>

      {/* RIGHT SIDE */}
<Col xs={24} lg={10}>
        <Card title="Recent Trades">
          
          {tableData.slice(0,5).map((item) => (
            <div
              key={item.key}
            style={{
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 0",
  borderBottom: "1px solid #f0f0f0",
  flexWrap: "wrap",
  gap: 8,
}}
            >
              <div>
                <div>{item.instrument}</div>
                <small>{item.date}</small>
              </div>

              <div>
                <div>Entry: {item.entry}</div>
             <div
  style={{
    color: item.pnl > 0 ? "#2ecc71" : "#e74c3c",
  }}
>
  ₹{Number(item.pnl).toFixed(2)}
</div>
              </div>
            </div>
          ))}

        </Card>
      </Col>

    </Row>
  );
};

export default TradesSection;